import http from "./http";
import { buildUrlFromLocation } from "@/utils/httpUtils";

export default {
    async create(payload) {
        return await http.post(buildUrlFromLocation("/admin/zone-groups", { campaignId: null }), payload);
    },
    async delete(id) {
        return await http.delete(buildUrlFromLocation("/admin/zone-groups/" + id, { campaignId: null }));
    },
    async listByPeriodForDashboard(periodId) {
        return await http.get(buildUrlFromLocation("/periods/" + periodId + "/zone-groups/dashboard", { campaignId: null }));
    }
};



// WEBPACK FOOTER //
// ./src/services/zoneGroup.js